import React from 'react';
import { t } from 'ttag';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { ZookeeperFiona } from '../../../sorting/characters/Zookeepers';

const MissionOutro: React.FC<ISlide> = ({ defaultHeader, nextSlide }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: ZookeeperFiona,
            text: t`Wow! That was fast! You were so speedy with your algorithms, you really are saving the day!`,
            buttonText: t`Thanks!`,
        },
        {
            character: ZookeeperFiona,
            text: t`I’m going to pass you onto Leanne for the final group of animals. I think these last few may be trickier...`,
            buttonText: t`Next!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default MissionOutro;
